import React from 'react';
import { DialogHeader, DialogTitle } from './ui/dialog';

// Style Pack §8.4 — modal Save/Cancel live at the TOP beside the title.
export const DialogTopBar = ({ title, titleClassName = '', children }) => (
    <DialogHeader className="flex-row items-center justify-between gap-4 space-y-0 border-b border-gray-200 pb-3 pr-10 text-left">
        <DialogTitle className={`font-heading text-lg font-semibold text-ica-navy flex items-center gap-2 ${titleClassName}`}>
            {title}
        </DialogTitle>
        <div className="flex items-center gap-2 flex-shrink-0">{children}</div>
    </DialogHeader>
);
